export { default } from './MaoNaRoda25Condicoes';
